'use client';

import { Link } from '@packages/modules/src/Link/Link';
import { useIntl } from 'react-intl';

type ExtendedRecoLinkProps = {
  /**
   * The link to the extended view page
   */
  link: string;
  /**
   * Optional click handler for e.g. tracking purposes
   */
  onClick?: () => void;
};

export const ExtendedRecoLink = ({ link, onClick }: ExtendedRecoLinkProps) => {
  const { formatMessage } = useIntl();
  return (
    <Link href={link} className="mt-1.5 inline-flex items-center leading-none" onClick={onClick}>
      {formatMessage({
        id: 'extendedRecoLink.title',
        defaultMessage: 'Entdecke mehr interessante Artikel',
      })}
      <span className="icon-emp-arrow-mini-right h-4 w-4" />
    </Link>
  );
};
